// The UI is English-only; the viewer's locale would print "10 January 2026".
const DATE_LOCALE = 'en-US';

/** "January 10, 2026" — the mockup dates every shipment in full. */
export function formatShippingDate(iso: string): string {
  const time = Date.parse(iso);
  if (!Number.isFinite(time)) return '';
  return new Date(time).toLocaleDateString(DATE_LOCALE, { year: 'numeric', month: 'long', day: 'numeric' });
}
